import type { VoicePreset, VoicePresetCreateInput, VoicePresetUpdateInput } from './types';

export async function listVoicePresets(): Promise<VoicePreset[]> {
  const res = await fetch('/api/voice-presets');
  if (!res.ok) throw new Error(`listVoicePresets: ${res.status}`);
  const data = await res.json();
  return data.presets as VoicePreset[];
}

export async function getVoicePreset(id: string): Promise<VoicePreset | null> {
  const res = await fetch(`/api/voice-presets/${encodeURIComponent(id)}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`getVoicePreset: ${res.status}`);
  const data = await res.json();
  return data.preset as VoicePreset;
}

export async function createVoicePreset(input: VoicePresetCreateInput): Promise<VoicePreset> {
  const res = await fetch('/api/voice-presets', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`createVoicePreset: ${res.status}`);
  const data = await res.json();
  return data.preset as VoicePreset;
}

export async function patchVoicePreset(
  id: string,
  input: VoicePresetUpdateInput,
): Promise<VoicePreset> {
  const res = await fetch(`/api/voice-presets/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`patchVoicePreset: ${res.status}`);
  const data = await res.json();
  return data.preset as VoicePreset;
}

export async function deleteVoicePreset(
  id: string,
  opts: { force?: boolean } = {},
): Promise<{ ok: true } | { ok: false; usedByCount: number }> {
  const qs = opts.force ? '?force=1' : '';
  const res = await fetch(`/api/voice-presets/${encodeURIComponent(id)}${qs}`, {
    method: 'DELETE',
  });
  if (res.status === 409) {
    const data = await res.json();
    return { ok: false, usedByCount: data.usedByCount as number };
  }
  if (!res.ok) throw new Error(`deleteVoicePreset: ${res.status}`);
  return { ok: true };
}
